"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assets = exports.isPublicAssetListVersionsParams = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
const isPublicAssetListVersionsParams = (params) => !!params.shortId;
exports.isPublicAssetListVersionsParams = isPublicAssetListVersionsParams;
function listVersions(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { cursor, limit, assetId } = params;
        if ((0, exports.isPublicAssetListVersionsParams)(params)) {
            const { shortId } = params;
            return (0, request_1.airRequest)(types_1.EndpointType.assets, {
                method: 'GET',
                endpoint: `shorturl/${shortId}/${assetId}/versions?${(0, util_1.formatParamsForHttp)({
                    cursor,
                    limit,
                })}`,
                authorized: 'optional',
                shortUrlProtection: { id: shortId },
            });
        }
        const { workspaceId } = params;
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            method: 'GET',
            endpoint: `${assetId}/versions?${(0, util_1.formatParamsForHttp)({
                cursor,
                limit,
            })}`,
            workspaceId,
        });
    });
}
/**
 * API to bulk fetch asset cover version (clip) details by provided assetIds
 */
function listCoverVersionsByAssetIds(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId } = input, rest = __rest(input, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: 'versions/listCoverVersionsByAssetIds',
            method: 'POST',
            workspaceId,
            body: rest,
        });
    });
}
/**
 * API to query for simplified current cover AssetVersion (Clip) information for two-way sync clients.
 * Results are paged and sorted by ascending `updatedAt`.
 */
function listCoverVersionsForSync(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, options = __rest(_a, ["workspaceId"]);
        // If libraryId is null, pass as a 'null' query param value...
        const libraryId = options.libraryId === null ? 'null' : options.libraryId;
        const { libraryId: _ } = options, rest = __rest(options, ["libraryId"]);
        const opts = Object.assign(Object.assign({}, rest), { libraryId });
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `versions/listCoverVersionsForSync?${(0, util_1.formatParamsForHttp)(opts)}`,
            workspaceId,
        });
    });
}
function updateVersion(_a) {
    return __awaiter(this, arguments, void 0, function* ({ clip, boardId, workspaceId, }) {
        const { id: clipId, assetId } = clip;
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `${assetId}/versions/${clipId}`,
            method: 'PATCH',
            body: clip,
            workspaceId,
            boardContext: boardId,
        });
    });
}
function merge(_a) {
    return __awaiter(this, arguments, void 0, function* ({ assetId, assetsToMerge, options, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `${assetId}/merge`,
            method: 'POST',
            workspaceId,
            body: {
                assetsToMerge,
            },
            boardContext: options === null || options === void 0 ? void 0 : options.boardId,
        });
    });
}
function extractVersion(_a) {
    return __awaiter(this, arguments, void 0, function* ({ assetId, clipId, options, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `${assetId}/versions/extract`,
            method: 'POST',
            body: {
                clipId,
                options,
            },
            workspaceId,
            boardContext: options === null || options === void 0 ? void 0 : options.boardId,
        });
    });
}
function batchDelete(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, assetIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            method: 'DELETE',
            endpoint: `batch`,
            workspaceId,
            body: { assetIds },
        });
    });
}
/**
 * Reprocesses a PDF asset version to use an alternative page as a thumbnail, with
 * frameNumber being 0-indexed and defaulting to 0 in the media processor on upload
 */
function reprocessAssetVersion(_a) {
    return __awaiter(this, arguments, void 0, function* ({ assetId, clipId, frameNumber, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            method: 'POST',
            endpoint: `${assetId}/versions/${clipId}/reprocess`,
            workspaceId,
            body: { frameNumber },
        });
    });
}
function listCustomFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ assetId, options = {}, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `${assetId}/customfields?${(0, util_1.formatParamsForHttp)(options)}`,
            workspaceId,
        });
    });
}
/**
 * Types distinguish between optional and nonoptional props
 */
function setCustomFieldValue(_a) {
    return __awaiter(this, arguments, void 0, function* ({ customFieldId, assetIds, valueId, plainTextValue, dateValue, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `customfields/${customFieldId}`,
            method: 'PUT',
            workspaceId,
            body: {
                assetIds,
                valueId,
                plainTextValue,
                dateValue,
            },
        });
    });
}
/**
 * Sets asset-level custom field values for multi-select custom field value types, supports
 * batch updating as well
 */
function setCustomFieldValues(_a) {
    return __awaiter(this, arguments, void 0, function* ({ customFieldId, assetIds, valueIdsToAdd, valueIdsToRemove, workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `customfields/${customFieldId}`,
            method: 'PUT',
            workspaceId,
            body: {
                assetIds,
                valueIdsToAdd,
                valueIdsToRemove,
            },
        });
    });
}
function listChanged(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.assets, {
            endpoint: `changed?${(0, util_1.formatParamsForHttp)(rest)}`,
            method: 'GET',
            workspaceId,
        });
    });
}
exports.Assets = Object.assign({ listVersions,
    listCoverVersionsByAssetIds,
    listCoverVersionsForSync,
    updateVersion,
    merge,
    extractVersion,
    batchDelete,
    reprocessAssetVersion,
    listCustomFields,
    setCustomFieldValue,
    setCustomFieldValues,
    listChanged }, (0, util_1.sdkToApi)(server_sdk_1.Assets));
//# sourceMappingURL=assets.js.map